import type { SxProps, Theme } from "@mui/material/styles";

import {
  settingsControlFontSize,
  settingsInputMinHeightPx
} from "~/features/settings/settings.styles";

export const overviewOverviewFieldsTwoColumnBp = "md";

/** Max width for port configuration cards on large viewports. */
export const workstationPreviewConfigCardMaxWidthPx = 440;
/** Max width for Put To Light cards (fewer fields than port cards). */
export const workstationPreviewPtlCardMaxWidthPx = 320;

export const newSettingsOutlinedInputSx: SxProps<Theme> = {
  "& .MuiOutlinedInput-root": {
    minHeight: settingsInputMinHeightPx,
    alignItems: "center"
  },
  "& .MuiInputBase-input": {
    boxSizing: "border-box",
    paddingTop: "8.5px",
    paddingBottom: "8.5px",
    fontSize: settingsControlFontSize,
    lineHeight: 1.35
  }
};

export const newSettingsAutocompleteInputWrapSx: SxProps<Theme> = {
  "& .MuiOutlinedInput-root": {
    minHeight: settingsInputMinHeightPx,
    alignItems: "center",
    flexWrap: "nowrap",
    alignContent: "center"
  },
  "& .MuiAutocomplete-inputRoot": {
    flexWrap: "nowrap",
    alignItems: "center"
  },
  "& .MuiInputBase-input": {
    boxSizing: "border-box",
    paddingTop: "8.5px",
    paddingBottom: "8.5px",
    minHeight: "0 !important",
    cursor: "pointer",
    fontSize: settingsControlFontSize,
    lineHeight: 1.35
  }
};

export const newSettingsAutocompleteTextFieldSx: SxProps<Theme> = {
  ...newSettingsOutlinedInputSx,
  ...newSettingsAutocompleteInputWrapSx,
  "& .MuiInputBase-input": {
    boxSizing: "border-box",
    paddingTop: "8.5px",
    paddingBottom: "8.5px",
    minHeight: "0 !important",
    cursor: "pointer",
    fontSize: settingsControlFontSize,
    lineHeight: 1.35
  }
};

export const overviewAutocompleteSx: SxProps<Theme> = {
  "& .MuiOutlinedInput-root.MuiInputBase-sizeSmall": {
    flexWrap: "nowrap",
    alignItems: "center",
    paddingLeft: "14px",
    paddingTop: 0,
    paddingBottom: 0
  },
  "& .MuiAutocomplete-input": {
    paddingLeft: "0 !important",
    paddingRight: "0 !important",
    flexGrow: 0,
    minWidth: "0 !important",
    width: 0
  }
};

/** Single-line display for overview Autocomplete tags (roles, order types, temp zones). */
export const overviewAutocompleteTagsDisplaySx: SxProps<Theme> = {
  display: "block",
  flex: 1,
  minWidth: 0,
  pointerEvents: "none",
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
  fontSize: settingsControlFontSize,
  lineHeight: 1.35
};
